export function getSearchParam(paramKey: string) {
  if (!String.prototype.startsWith) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(String.prototype, 'startsWith', {
      value(search: any, rawPos: any) {
        // eslint-disable-next-line no-bitwise
        const pos = rawPos > 0 ? rawPos | 0 : 0;
        return this.substring(pos, pos + search.length) === search;
      }
    });
  }

  const param = window.location.search
    .replace('?', '')
    .split('&')
    .filter(a => a.startsWith(`${paramKey}=`));
  if (param && param.length > 0) return param[0].split('=')[1];
  return '';
}
